import { render, staticRenderFns } from "./LoadContainer.vue?vue&type=template&id=1a2d230c"
import script from "./LoadContainer.vue?vue&type=script&lang=js"
export * from "./LoadContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports